import React from 'react';
import './style.scss';

export const Button = (props) => {
  const { children } = props;
  return <button {...props}>{children}</button>;
};

export const PrimaryButton = (props) => {
  return <Button className={'primary'} {...props} />;
};

export const SecondaryButton = (props) => {
  return <Button className={'secondary'} {...props} />;
};
